import React from "react";

import Layout from "../components/ui/Layout";
import Header from "../components/ui/Header";
import { Box } from "rebass/styled-components";
import Section from "../components/ui/Section";
import Seo from "../components/ui/Seo";
const MortgageIndex = ({ data }) => {
  const iframe = `<iframe
  src="https://the-capilitan-group.gettrail.com/Calculator/Repayment/7f1fab4a-c3da-46b3-8df5-9ac3c2e894aa"
  style="border:none; width:320px; margin-left:auto; margin-right:auto; min-height:600px;"
></iframe>`;

  const iframe2 = `<iframe
  src="https://the-capilitan-group.gettrail.com/Calculator/Term/7f1fab4a-c3da-46b3-8df5-9ac3c2e894aa"
  style="border:none; width:800px; margin-left:auto; margin-right:auto;min-height:700px; "
></iframe>`;

  const iframeHHTML = () => {
    return {
      __html: iframe,
    };
  };

  const iframe2HHTML = () => {
    return {
      __html: iframe2,
    };
  };
  return (
    <Layout>
      <Seo title="Mortgage Calculator" />
      <Header title="Mortgage Calculator" />

      <Section>
        <Box p={3} m="5rem auto" maxWidth="900px" textAlign="center">
          <h2>What will my repayments be?</h2>
          <div
            style={{ marginBottom: "5rem" }}
            dangerouslySetInnerHTML={iframeHHTML()}
          />
          <h3>What difference will my repayments make?</h3>
          <div dangerouslySetInnerHTML={iframe2HHTML()} />
        </Box>
      </Section>
    </Layout>
  );
};
export default MortgageIndex;
